import React from 'react';
import { useTranslation } from 'react-i18next';
import Headline from '../UI/Headline/Headline';
import bg from '../../assets/images/how_it_works_bg.png';
import classes from './HowItWorks.module.scss';

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      title: t('pages.main.howItWorks.step1.title'),
      text: t('pages.main.howItWorks.step1.text')
    },
    {
      number: '02',
      title: t('pages.main.howItWorks.step2.title'),
      text: t('pages.main.howItWorks.step2.text')
    },
    {
      number: '03',
      title: t('pages.main.howItWorks.step3.title'),
      text: t('pages.main.howItWorks.step3.text')
    }
  ];

  return (
    <section className={classes.section}>
      <Headline>{t('pages.main.howItWorks.title')}</Headline>
      <h4 style={{ marginBottom: 40, marginTop: 60 }}>
        {t('pages.main.howItWorks.text')}
      </h4>
      <div
        className={classes.card}
        style={{ backgroundImage: `url(${bg})` }}
      >
        {steps.map((step) => (
          <div key={step.number} className={classes.step}>
            <div className={classes.number}>{step.number}</div>
            <div className={classes.divider} />
            <h3 className={classes.title}>{step.title}</h3>
            <p className={classes.text}>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
